import { render } from "./InternetTicket.vue?vue&type=template&id=40f2505e"
import script from "./InternetTicket.vue?vue&type=script&lang=js"
export * from "./InternetTicket.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "40f2505e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40f2505e', script)) {
    api.reload('40f2505e', script)
  }
  
  module.hot.accept("./InternetTicket.vue?vue&type=template&id=40f2505e", () => {
    api.rerender('40f2505e', render)
  })

}

script.__file = "src/views/services/modules/internet/pills/InternetTicket.vue"

export default script